import Bugsnag from "@bugsnag/js";
import { getQueryParams } from "@/utils/httpRequest";
import { contactService } from "@/modules/contacts/store/services/contact-service";
import { CONTACT_SERVICE_TAG } from "@/modules/contacts/utils/contact-service-tags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";

const getContacts = contactService.injectEndpoints({
  endpoints: builder => ({
    getContacts: builder.query({
      query: ({ params }) => `contacts?${getQueryParams(params)}`,
      providesTags: result =>
        result
          ? [
              ...result.items.map(({ contactId }) => ({ type: CONTACT_SERVICE_TAG, contactId })),
              { type: CONTACT_SERVICE_TAG, id: LIST_SERVICE_TAG },
            ]
          : [{ type: CONTACT_SERVICE_TAG, id: LIST_SERVICE_TAG }],
      async onQueryStarted({ params, setParams }, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (!data.items.length && params.page > 1) {
            setParams(prevParams => ({ ...prevParams, page: prevParams.page - 1 }));
          }
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetContactsQuery } = getContacts;

